

import msDataProvider from "@/services/msDataProvider";
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      emails: [],
      phones: []
    }
  },
  async created() {
    const res: any = await msDataProvider.getData("clientSetting");
    if (res && res.settings && res.settings.contact_admins) {
      const contactAdmins = res.settings.contact_admins;
      this.emails = contactAdmins.map(admin => admin.email) || [];
      this.phones = contactAdmins.map(admin => admin.phone_number) || [];
    } else if (res  && res.settings && res.settings.contact_admin) {
      const contactAdmin = res.settings.contact_admin;
      if (Array.isArray(contactAdmin.email)) {
        this.emails = contactAdmin.email
      }

      if (Array.isArray(contactAdmin.phone_number)) {
        this.phones = contactAdmin.phone_number
      }
    }
  },
  methods: {
    async goToHelpCenter() {
      const baseUrl = "https://localhost:40001/ui";
      const url = "/user-guide/index";
      const authenToken = sessionStorage.getItem("authenToken") || "";
      let authorizedToken = "";
      if (authenToken) {
        authorizedToken = `authorized_token=${authenToken}`;
      }
      try {
        await msDataProvider.executeCommand("extOpenUrl", {
          url: baseUrl + url + "?" + authorizedToken,
        });
      } catch (e) {
        console.log(e);
      }
    },

    async goToTroubleShootingPage() {
      const baseUrl = "https://localhost:40001/ui";
      const url = "/user-guide/index?#iii-h%C6%B0%E1%BB%9Bng-d%E1%BA%ABn-kh%E1%BA%AFc-ph%E1%BB%A5c-l%E1%BB%97i";
      try {
        // window.open(baseUrl + url, "_blank");
        await msDataProvider.executeCommand("extOpenUrl", {
          url: baseUrl + url,
        });
      } catch (e) {
        console.log(e);
      }
    }
  },

})
